// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { CodeMirrorEditorFactory } from './factory';
import { CodeMirrorMimeTypeService } from './mimetype';
export * from './mode';
export * from './editor';
export * from './factory';
export * from './mimetype';
export * from './syntaxstatus';
/**
 * The default editor services.
 */
export const editorServices = {
    factoryService: new CodeMirrorEditorFactory(),
    mimeTypeService: new CodeMirrorMimeTypeService()
};
//# sourceMappingURL=index.js.map